module.exports = __webpack_public_path__ + "img/Apoptosis-BRCA_10X_Section1.04fd615f.png";